/* istanbul ignore file */
import * as React from 'react'
import type { SVGProps } from 'react'
import PropTypes from 'prop-types'

interface Props extends SVGProps<SVGSVGElement> {
  srText?: string
  size?: 'sm' | 'md' | 'lg' | 'scale-8' | 'scale-10' | number
  alt?: string
}
function IconInstitution({
  srText,
  size = 'md',
  className = '',
  ...props
}: Props) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`
  return (
    <>
      {!!srText && <span className='mc-sr-only'>{srText}</span>}
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={24}
        height={24}
        viewBox='0 0 24 24'
        aria-hidden='true'
        role='img'
        className={newClassName}
        {...props}
      >
        <defs>
          <clipPath id='institution_svg__a'>
            <path d='M2 21h21.98v2.293H2Zm0 0' />
          </clipPath>
          <clipPath id='institution_svg__b'>
            <path d='M2 19h21.98v2H2Zm0 0' />
          </clipPath>
          <clipPath id='institution_svg__c'>
            <path d='M3 .707h19V9H3Zm0 0' />
          </clipPath>
        </defs>
        <path
          fill='none'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.1477608799999999}
          d='M8.453 8.387H5.63v8.468h2.824ZM14.102 8.387h-2.825v8.468h2.825ZM19.746 8.387h-2.824v8.468h2.824ZM21.16 19.68H4.22v-2.117a.707.707 0 0 1 .703-.708h15.531a.707.707 0 0 1 .707.708Zm0 0'
        />
        <g clipPath='url(#institution_svg__a)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.1477608799999999}
            d='M2.805 22.504H22.57'
          />
        </g>
        <g clipPath='url(#institution_svg__b)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.1477608799999999}
            d='M2.805 19.68H22.57'
          />
        </g>
        <g clipPath='url(#institution_svg__c)'>
          <path
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.1477608799999999}
            d='M21.16 5.563V7.68a.707.707 0 0 1-.707.707H4.922a.707.707 0 0 1-.703-.707V5.563l8.152-4.079a.74.74 0 0 1 .317-.074c.109 0 .218.028.316.074Zm0 0'
          />
        </g>
        <path
          fill='none'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.1477608799999999}
          d='M4.219 5.563H21.16'
        />
      </svg>
    </>
  )
}
IconInstitution.propTypes = {
  srText: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
} as PropTypes.ValidationMap<Props>
export default IconInstitution
